<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  globalData: {
    userInfo: {
      accountName: "",
      role: 1,
      group: 0,
      token: ""
    }
  },
  userGroup: [{
      value: 1,
      label: '用户运营'
  }, {
      value: 2,
      label: '商业化'
  }, {
      value: 4,
      label: '活动运营'
  }, {
      value: 8,
      label: '内容运营'
  }, {
      value: 16,
      label: '管理员'
  }, {
      value: 32,
      label: '超级管理员'
  }],
  userGroupWithOutSu: [{
      value: 1,
      label: '用户运营'
  }, {
      value: 2,
      label: '商业化'
  }, {
      value: 4,
      label: '活动运营'
  }, {
      value: 8,
      label: '内容运营'
  }, {
      value: 16,
      label: '管理员'
  }],
  templateType: [{
      value: 1,
      label: '纯文本'
  }, {
      value: 2,
      label: '图文模板'
  }, {
      value: 3,
      label: '视频文本'
  }],
  signOut() {
    var data = {
      accountName: "",
      role: 1,
      group: 0,
      token: ""
    }
    sessionStorage.setItem("userInfo", JSON.stringify(data));
  }
}
</script>

<style>
*{
  margin: 0;
  padding: 0;
}
html,body {
  width: 100%;
  height: 100%;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue